import { useState, useEffect } from 'react';

const useScreenType = (size: number) => {
  const [screenType, setScreenType] = useState('desktop');

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= (size || 768)) {
        setScreenType('mobile');
      } else {
        setScreenType('desktop');
      }
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return screenType;
};

export default useScreenType;
